import PropTypes from 'prop-types';
import React from 'react';
import { WeekDays } from '../../utils/weekdays';
import './styles.scss';

const ScheduleSummaryView = ({schedule, specials}) => {
  const timeSlots = [];

  WeekDays.daysShort.forEach(day => {
    if (schedule[day].length > 1) {
      timeSlots.push(
        <div key={day} className="entry">
          <strong>{WeekDays[day]} slots:</strong>
          {schedule[day].filter(entry => !entry.default).map(entry => (
            <span key={entry.id}>{entry.start_time} to {entry.end_time}</span>
          ))}
        </div>,
      );
    }
  });

  return (
    <div className="schedule-summary">
      {timeSlots.length ? timeSlots : 'No time slots'}
      {specials.length > 0 &&
      <div className="entry">
        <strong>Special events on:</strong>
        {specials.map(entry => (<span key={entry.id}>{entry.date}</span>))}
      </div>
      }
    </div>
  );
};

ScheduleSummaryView.propTypes = {
  schedule: PropTypes.object.isRequired,
  specials: PropTypes.array.isRequired,
};

export default ScheduleSummaryView;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/ScheduleSummaryView/index.js